import { render, staticRenderFns } from "./ProductCard.vue?vue&type=template&id=644b9117&scoped=true&"
import script from "./ProductCard.vue?vue&type=script&lang=js&"
export * from "./ProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ProductCard.vue?vue&type=style&index=0&id=644b9117&lang=sass&scoped=true&"
import style1 from "./ProductCard.vue?vue&type=style&index=1&id=644b9117&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "644b9117",
  null
  
)

export default component.exports